import { CustomArray } from "../../../common/CustomArray";
import { SegmentLineItem } from "./SegmentLineItem";
import { ArrayUtility } from "../../../common/ArrayUtility";


export class SegmentLineItems extends CustomArray {

	constructor() {
		super();
	}




	/**
	 * 获取坐标点数组
	 */
	getPoints()
	{	
		let pnts=new Array();

		let tempLineItem=null;
		let tempPnts=null;
		for(let tempItemIndex=0;tempItemIndex<this.objects.length;tempItemIndex++)
		{	
			tempLineItem=this.objects[tempItemIndex];
			tempPnts = tempLineItem.getPoints();
			ArrayUtility.addTargetToOri(pnts,tempPnts);
		}

		return pnts;
	}


	getStationCount()
	{	
		let stationCount=0;

		let tempItem = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempItem = this.objects[tempIndex];
			if(tempItem.segmentStationCount)
			{
				stationCount+=tempItem.segmentStationCount;
			}
		
		}

		return stationCount;
	}

	getLinesDescription() {
		let desc = null;

		let lineCount = this.objects.length;
		if (lineCount === 1) {
			if(this.objects[0].lineName)
			{
				desc = this.objects[0].lineName;
			}
			else
			{
				desc="";
			}
		}
		else if (lineCount > 1) {
			let tempItem = null;
			let tempItemName = null;
			for (let tempIndex = 0; tempIndex < lineCount; tempIndex++) {
				tempItem = this.objects[tempIndex];
				tempItemName = tempItem.lineName;
				if(!tempItemName)continue;
				if (tempIndex === 0) {
					desc = tempItemName + "(或";
				}
				else if (tempIndex === lineCount - 1) {
					desc += tempItemName + ")";
				}
				else if (tempIndex < lineCount - 1) {
					desc += tempItemName + "、";
				}
			}
		}

		return desc;
	}


	/**
	 * 获取所有线路名称数组
	 */
	getLineNames() {
		let lineNames = new Array();
		let tempItem = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempItem = this.objects[tempIndex];
			if(tempItem.lineName)
			{
				lineNames.push(tempItem.lineName);
			}
			
		}

		return lineNames;
	}


	static GetSegmentLineItems(jsonItems) {
		let lineItems = new SegmentLineItems();
		if (jsonItems == null) return lineItems;
		
		let tempLineItem = null;
		for (let tempIndex in jsonItems) {
			tempLineItem = SegmentLineItem.GetSegmentLineItem(jsonItems[tempIndex]);
			lineItems.push(tempLineItem);
		}

		return lineItems;
	}

}//end SegmentLineItems

